import styled, { css } from 'styled-components';
import TeamModal from '../../TeamModal';
import { Content } from '../../TeamModal/Wrapper';

export const TeamModalWrapper = styled(TeamModal)`
  ${Content} {
    width: 680px;
    max-width: 700px;
    display: flex;
    padding: 0;
  }
`;
export const RightSide = styled.div`
  width: 100%;
`;
export const LeftSide = styled.div`
  padding: 10px;
  min-width: 180px;
  border-right: 1px solid #e0e7eb;
`;

export const List = styled.div``;
export const Item = styled.div<{ isActive: boolean }>`
  padding: 10px;
  cursor: pointer;
  ${({ isActive }) =>
    isActive &&
    css`
      background: #30aef2;
      border-radius: 5px;
      color: #fff;
    `}
`;
export const Name = styled.div`
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
`;
export const Role = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
`;
